import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
import { gethistory } from "../../../Services/Superadmin/Superadmin";
import { DollarSign } from "lucide-react";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const Transaction = () => {
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [activeWallet, setActiveWallet] = useState("USD");

  useEffect(() => {
    getallhistory();
  }, [search, activeWallet, rowsPerPage, page]);

  const columns = [
    {
  Header: "S.No",
  id: "rowIndex",
  Cell: ({ row, index }) => {
    return (page - 1) * rowsPerPage + (index + 1);
  }
},
    {
      Header: "UserName",
      accessor: "UserName",
      Cell: ({ row }) => row["UserName"] || "--",
    },

    {
      Header: "Balance",
      accessor: "Balance",
      Cell: ({ row }) => (
        <span>
          {activeWallet === "USD" ? "$" : "₹"}
          {Number(row["Balance"] || 0).toFixed(2)}
        </span>
      ),
    },

    {
      Header: "Status",
      accessor: "Type",
      Cell: ({ row }) => {
        const value = row["Type"];
        return (
          <span style={{ color: value === "CREDIT" ? "green" : "red" }}>
            {value || "--"}
          </span>
        );
      },
    },

    {
      Header: "Create Date",
      accessor: "createdAt",
      Cell: ({ row }) => {
        const date = row["createdAt"];
        return date ? fDateTimesec(date) : "--"; // SAFE FIX
      },
    },
  ];


  const getallhistory = async () => {
    try {
      const response = await gethistory({
        type: activeWallet,
        page,
        limit: rowsPerPage,
        search
      });

      setData(response.data);
      setTotalPages(response?.pagination?.totalPages || 1);
    } catch (error) { }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
  };

  return (
    <>
      <div>
        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col-lg-12">
              <div className="card transaction-table custom-bg">
                <div className="card-header border-0 flex-wrap ">
                  <div className="d-flex align-items-center justify-content-between w-100">
                    {/* Left Side */}
                    <h4 className="card-title">Transaction History</h4>

                    {/* Right Side */}
                    <div className="wallet-tabs">
                      <div className="btn-group " role="group">
                        {TokenData?.market.includes(0) && (
                          <button
                            type="button"
                            className={`btn ${activeWallet === "USD"
                              ? "btn-primary"
                              : "btn-outline-primary"
                              }`}
                            onClick={() => setActiveWallet("USD")}
                          >
                            <i className="fas fa-dollar-sign me-2"></i>
                            USD Wallet
                          </button>
                        )}
                        {TokenData?.market.includes(1) && (
                          <button
                            type="button"
                            className={`btn ${activeWallet === "INR"
                              ? "btn-primary"
                              : "btn-outline-primary"
                              }`}
                            onClick={() => setActiveWallet("INR")}
                          >
                            <i className="fas fa-rupee-sign me-2"></i>
                            INR Wallet
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-body p-0">
                  <div className="tab-content" id="myTabContent1">
                    <div
                      className="tab-pane fade show active"
                      id="Week"
                      role="tabpanel"
                      aria-labelledby="Week-tab"
                    >
                      <div className=" gap-2 mb-3 ms-4 mt-4">
                        <label className="fw-bold mb-0">🔍 Search:</label>

                        <input
                          className="form-control"
                          style={{
                            width: "250px",
                            height: "40px"
                          }}
                          type="text"
                          placeholder="Search..."
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                        />
                      </div>

                      <Table
                        columns={columns}
                        data={data}
                        page={page}
                        totalPages={totalPages}
                        initialRowsPerPage={rowsPerPage}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                      />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Transaction;
